import React from 'react';
import AdminManageSettingsDataUpload from './admin-manage-settings-data-upload';
import AdminManageSettingsComparisonTable from './admin-manage-settings-comparison-table';
import * as adminService from '../../services/admin-service';

const fumosConfig = {
  title: 'Manage FUMOs',
  description: 'Upload an Excel file containing Managing Office data (corp_list) to compare with existing records and update as needed.',
  uploadTitle: 'Upload FUMOs File',
  entityName: 'FUMOs',
  fileInputId: 'fumos',
  uploadService: adminService.uploadFumosFile,
  bulkUpdateService: adminService.bulkUpdateFumos,
  downloadFileService: adminService.downloadFumosFile,
  getFileInfoService: adminService.getFumosFileInfo,
  // Table configuration - based on corp_list Excel structure
  idField: 'fumo_code', // fumo_code is the unique identifier
  columns: [
    { field: 'fumo_code', label: 'FUMO Code', className: 'admin-pool-comparison-col-fumo' },
    { field: 'managing_office_code', label: 'Managing Office Code', className: 'admin-pool-comparison-col-code' },
    { field: 'managing_office_name', label: 'Managing Office Name', className: 'admin-pool-comparison-col-name' },
    { field: 'division_market_area', label: 'Division Market Area', className: 'admin-pool-comparison-col-division' },
    { field: 'functional_unit_code', label: 'Functional Unit Code', className: 'admin-pool-comparison-col-func-code' },
    { field: 'functional_unit_name', label: 'Functional Unit Name', className: 'admin-pool-comparison-col-func-name' },
    { field: 'line_of_business', label: 'Line of Business', className: 'admin-pool-comparison-col-lob' },
    { field: 'line_of_business_subdivision', label: 'LOB Subdivision', className: 'admin-pool-comparison-col-lob-sub' },
    { field: 'local_market_area', label: 'Local Market Area', className: 'admin-pool-comparison-col-local' },
  ],
  viewAllConfig: {
    entityName: 'FUMOs',
    fetchAllService: adminService.fetchFumos,
    idField: 'fumo_code',
    searchFields: ['fumo_code', 'managing_office_code', 'managing_office_name', 'functional_unit_code'],
    columns: [
      { key: 'fumo_code', label: 'FUMO CODE', width: '150px' },
      { key: 'managing_office_code', label: 'MANAGING OFFICE CODE', width: '200px' },
      { key: 'managing_office_name', label: 'MANAGING OFFICE NAME', width: '220px' },
      { key: 'functional_unit_code', label: 'FUNCTIONAL UNIT CODE', width: '200px' },
      { key: 'functional_unit_name', label: 'FUNCTIONAL UNIT NAME', width: '220px' },
      { key: 'division_market_area', label: 'DIVISION MARKET AREA', width: '220px' },
      { key: 'local_market_area', label: 'LOCAL MARKET AREA', width: '200px' },
      { key: 'line_of_business', label: 'LINE OF BUSINESS', width: '200px' },
      { key: 'line_of_business_subdivision', label: 'LOB SUBDIVISION', width: '200px' },
    ],
  },
};

const AdminManageFumos = () => {
  return (
    <AdminManageSettingsDataUpload
      config={fumosConfig}
      ComparisonTableComponent={AdminManageSettingsComparisonTable}
    />
  );
};

export default AdminManageFumos;

